import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Logger } from '@common-lib';
import { ActivatedRoute } from '@angular/router';
import { PluginGotenehusMappingService } from '../../pages-services/plugin-gotenehus-mapping.service';
import { ToasterService } from 'angular2-toaster';
import { TranslateService } from "@ngx-translate/core";
import { ConfirmPopupComponent } from "../../components/confirm-popup/confirm-popup.component";

@Component({
  selector: 'app-plugin-gotenehus-mapping',
  templateUrl: './plugin-gotenehus-mapping.component.html',
  styleUrls: ['./plugin-gotenehus-mapping.component.scss']
})
export class PluginGotenehusMappingComponent implements OnInit {

  editModalRef: BsModalRef;
  selectedRow: {
    id: number,
    tableName: string,
    localField: string,
    remoteField: string,
    remoteApi: string
  };
  searchTerm = '';

  @ViewChild('editFormTemplate')
  editFormTemplate: TemplateRef<any>;

  tables = [
    {
      name: 'variants',
      title: 'Variants'
    }, {
      name: 'plugin_gotenehus_product_regions',
      title: 'PG Product Regions'
    }, {
      name: 'plugin_gotenehus_regions',
      title: 'Regions'
    }
  ];

  tableConfiguration = {
    searchEnabled: false,
    headerEnabled: true,
    orderEnabled: true,
    globalSearchEnabled: false,
    paginationEnabled: true,
    exportEnabled: false,
    clickEvent: false,
    selectRow: false,
    selectCol: false,
    selectCell: false,
    rows: 50,
    additionalActions: false,
    serverPagination: false,
    isLoading: false,
    detailsTemplate: false,
    groupRows: false,
    paginationRangeEnabled: true,
    collapseAllRows: false,
    checkboxes: false
  };

  columns = [
    { key: 'id', title: 'ID' },
    { key: 'tableName', title: 'Table' },
    { key: 'localField', title: 'Local Field' },
    { key: 'remoteField', title: 'Remote Field' },
    { key: 'remoteApi', title: 'Remote Api' },
    { key: 'actions', title: '' }
  ];

  data = [];
  rows = [];
  selected = new Set();
  selectedLocale = 'en-EN';

  @ViewChild(ConfirmPopupComponent)
  confirmPopup: ConfirmPopupComponent;

  constructor(
    private route: ActivatedRoute,
    private pluginGotenehusMappingService: PluginGotenehusMappingService,
    private modalService: BsModalService,
    private logger: Logger,
    private toasterService: ToasterService,
    private translationService: TranslateService) {
  }

  ngOnInit() {
    this.getList();
  }

  getList() {
    this.pluginGotenehusMappingService.getList().subscribe((data) => {
      this.data = data;
      this.search();
    });
  }

  localeChanged() {
    this.pluginGotenehusMappingService.getList().subscribe((data) => {
      this.data = data;
      this.search();
    });
  }

  editRow(row) {
    this.selectedRow = row;
    //this.selectedRow.roles = (this.selectedRow.roles as string).split(',');
    this.editModalRef = this.modalService.show(this.editFormTemplate);
  }

  rowSelected(event) {
    if (event.event === 'onDoubleClick') {
      this.editRow(event.value.row);
    }
  }

  isRowSelected(row) {
    return this.selected.has(this.data.indexOf(row));
  }

  async saveData() {
    let sendObj = Object.assign({}, this.selectedRow);

    if (!sendObj.id) {
      this.pluginGotenehusMappingService
        .create(sendObj)
        .subscribe(async (result) => {
          this.getList();
          this.toasterService.pop('success', '', await this.translationService.get('webpanel.plugin_gotenehus_mapping.created_message').toPromise());
          this.editModalRef.hide();
        }, (err) => {
          this.toasterService.pop('error', '', err.message);
        });
    } else {
      this.pluginGotenehusMappingService
        .update(sendObj.id, sendObj)
        .subscribe((result) => {
          this.pluginGotenehusMappingService
            .getList()
            .subscribe(async (data) => {
              this.data = data;
              this.search();
              this.toasterService.pop('success', '', await this.translationService.get('webpanel.plugin_gotenehus_mapping.updated_message').toPromise());
              this.editModalRef.hide();
            });
        });
    }
  }

  search() {
    this.rows = this.data.filter((r) => this.searchTerm.length === 0 ||
      r.tableName.indexOf(this.searchTerm.toLowerCase) !== -1 ||
      r.localField.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
      r.remoteField.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1);
  }

  addNew() {
    this.selectedRow = {
      id: null,
      tableName: '',
      localField: '',
      remoteField: '',
      remoteApi: ''
    };
    this.editModalRef = this.modalService.show(this.editFormTemplate);
  }

  searchKeyPress(event) {
    if (event.which === 13) {
      this.search();
    }
  }

  async removeItem(item) {
    this.selectedRow = item;
    if (this.selectedRow) {
      this.confirmPopup.show();
    }
  }

  confirm(res) {
    if (res) {
      if (this.selectedRow) {
        this.pluginGotenehusMappingService.delete(this.selectedRow).subscribe(async (resp) => {
          this.selectedRow = null;
          let successMessage = await this.translationService.get('webpanel.plugin_gotenehus_mapping.delete.success_message').toPromise();
          this.toasterService.pop('success', '', successMessage);
          this.getList();
        });
      }
    } else {
      this.selectedRow = null;
    }
  }

  decline() {
    this.selectedRow = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/plugin-gotenehus-mapping/plugin-gotenehus-mapping.component.ts